/**
 * Helpers para renderizar e parsear menções tipadas: =user, @client, +external
 */
import React from "react";
import { openWhatsApp } from "@/lib/whatsapp";

export const MENTION_REGEX = /([=@+])([A-Za-z0-9_.\-çãáéíóúâêôÁÉÍÓÚÂÊÔÃÇ]+)/g;

const STYLE = {
  user: { bg: "#DBEAFE", color: "#1E40AF", label: "login" },
  client: { bg: "#FEF3C7", color: "#92400E", label: "cliente" },
  external: { bg: "#E5E7EB", color: "#374151", label: "externo" },
};

function symbolToType(symbol) {
  if (symbol === "=") return "user";
  if (symbol === "@") return "client";
  return "external";
}

/**
 * Renderiza texto com menções coloridas.
 * @cliente vira botão clicável que abre WhatsApp se houver telefone.
 */
export function renderMentions(text, mentionsTyped = [], clientsMap = {}) {
  if (!text) return null;
  const resolved = {};
  for (const m of mentionsTyped || []) {
    resolved[`${m.type}:${m.value}`] = m;
  }
  const parts = [];
  let last = 0;
  const re = new RegExp(MENTION_REGEX);
  let match;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    const symbol = match[1];
    const name = match[2];
    const type = symbolToType(symbol);
    const resolvedMatch = resolved[`${type}:${name.toLowerCase()}`];
    const display = resolvedMatch?.name || name;
    const s = STYLE[type];

    if (type === "client" && resolvedMatch?.ref_id && clientsMap[resolvedMatch.ref_id]?.phone) {
      const client = clientsMap[resolvedMatch.ref_id];
      parts.push(
        <button
          key={`${match.index}-${name}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openWhatsApp(client.phone, `Oi ${client.name}! 💖`);
          }}
          className="text-[11px] font-medium px-1.5 py-0.5 rounded mx-0.5 hover:underline cursor-pointer transition-colors"
          style={{ background: s.bg, color: s.color }}
          title={`Abrir WhatsApp de ${display}`}
        >
          {symbol}{display}
        </button>
      );
    } else {
      parts.push(
        <span
          key={`${match.index}-${name}`}
          className="text-[11px] font-medium px-1.5 py-0.5 rounded mx-0.5"
          style={{ background: s.bg, color: s.color }}
          title={`${s.label}: ${display}`}
        >
          {symbol}{display}
        </span>
      );
    }
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export { STYLE as MENTION_STYLE };
